import PageWrapper from "../components/ui/PageWrapper";
import ArticleCard from "../components/articles/ArticleCard";
import { articles } from "../data/articles";
import { motion } from "framer-motion";

export default function ArticlesPage() {
  return (
    <PageWrapper className="pt-28 pb-20 bg-terminal">
      <div className="max-w-4xl mx-auto px-6">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl md:text-4xl font-bold text-brightText mb-4"
        >
          Articles
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-dimText mb-12 max-w-2xl"
        >
          Thoughts on physics, machine learning, and technology.
        </motion.p>

        <div className="flex flex-col gap-6">
          {articles.map((article, index) => (
            <ArticleCard key={article.id} article={article} index={index} />
          ))}
        </div>
      </div>
    </PageWrapper>
  );
}
